import * as React from 'react';
import { Spinner as BPSpinner, Intent } from '@blueprintjs/core';

export const Spinner = () => (
  <div className="w-100 center measure">
  <BPSpinner intent={Intent.SUCCESS} className="pt-large"/>
  </div>
);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/spinner/index.tsx